import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { post } from "../../../../services/services";
import { ApiURL } from "../../../../services/apiConstants";
import RefrigerationEquipLogForm from "./RefrigerationEquipLogForm";

const ViewRefrigerationEquipLog = () => {
  const { id } = useParams();
  const [details, setDetails] = useState(null);

  useEffect(() => {
    const fd = new FormData();
    fd.append("id", id);

    post(ApiURL.ods_record_get, fd).then((res) => {
      if (res?.status === true) setDetails(res.data);
    });
  }, [id]);

  if (!details) return <h3>Loading...</h3>;

  return (
    <>
      <h2>View Refrigeration Equip Log</h2>
      <RefrigerationEquipLogForm
        records={[details]}
        readOnly
      />
    </>
  );
};

export default ViewRefrigerationEquipLog;
